import React from 'react'
import Helmet from 'react-helmet'
import { useStaticQuery, graphql } from 'gatsby'

type Props = {
    description?: string
    lang?: string
    meta?: any[]
    keywords?: string[]
    title?: string
}

function SEO({ description = ``, lang = `en`, meta = [], keywords, title = `` }: Props) {
    const { site } = useStaticQuery(
        graphql`
            query {
                site {
                    siteMetadata {
                        title
                        description
                        author
                        keywords
                    }
                }
            }
        `,
    )

    const metaDescription = description || site.siteMetadata.description
    const metaKeywords = keywords || site.siteMetadata.keywords

    return (
        <Helmet
            htmlAttributes={{
                lang,
            }}
            title={title}
            titleTemplate={`${site.siteMetadata.title}`}
            meta={[
                {
                    name: `description`,
                    content: metaDescription,
                },
                {
                    property: `og:title`,
                    content: title,
                },
                {
                    property: `og:description`,
                    content: metaDescription,
                },
                {
                    property: `og:type`,
                    content: `website`,
                },
                {
                    name: `twitter:card`,
                    content: `summary`,
                },
                {
                    name: `twitter:creator`,
                    content: site.siteMetadata.author,
                },
                {
                    name: `twitter:title`,
                    content: title,
                },
                {
                    name: `twitter:description`,
                    content: metaDescription,
                },
            ]
                .concat(
                    metaKeywords.length > 0
                        ? {
                              name: `keywords`,
                              content: metaKeywords.join(`, `),
                          }
                        : [],
                )
                .concat(meta)}
        />
    )
}

export default SEO
